import React from 'react'

const Cp_mStr = () => {
    return (
        <div className='container'>
            <h1>Return maximum occurring character in an input string</h1>
            <p><strong>Algorithm:</strong>&nbsp;<br/>
            One obvious approach to solve this problem would be to sort the input string and then traverse 
            through the sorted string to find the character which is occurring maximum number of times. Let
             us see if we can improve on this. So we will use a technique called ‘Hashing’. In this, when we
              traverse through the string, we would hash each character into an array of ASCII characters.&nbsp;
              <br/>
            &nbsp;</p>
            <pre className='output'>Input string = “test” <br />
1: Construct character count array from the input string. <br />
  count['e'] = 1 <br />
  count['s'] = 1 <br />
  count['t'] = 2 <br />
 <br />
2: Return the index of maximum value in count array (returns ‘t’). <br /></pre>
<p>Typically, ASCII characters are 256, so we use our Hash array size as 256. But if we know that our input string will have characters with value from 0 to 127 only, we can limit Hash array size as 128. Similarly, based on extra info known about input string, the Hash array size can be limited to 26.<br/>
<strong>Implementation:</strong><br/>
&nbsp;</p>
<div class="containers">
    <div class="line number1 index0 alt2"><code
            class="comment">//Program to output the maximum occurring character</code></div>
    <div class="line number2 index1 alt1"><code class="comment">// in a string</code></div>
    <div class="line number3 index2 alt2"><code class="library">#include&lt;bits/stdc++.h&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="library">#define ASCII_SIZE 256</code></div>
    <div class="line number5 index4 alt2"><code class="keywords">using</code> <code
            class="keywords">namespace</code> <code class="plain">std;</code></div>
    <div class="line number6 index5 alt1">&nbsp;</div>
    <div class="line number7 index6 alt2"><code class="keywords">char</code> <code
            class="plain">getMaxOccuringChar(</code><code class="keywords">char</code><code
            class="plain">* str)</code></div>
    <div class="line number8 index7 alt1"><code class="plain">&#123;</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// Create array to keep the count of individual</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// characters and initialize the array as 0</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">int</code> <code class="plain">count[ASCII_SIZE] = &#123;0&#125;;</code></div>
    <div class="line number12 index11 alt1">&nbsp;</div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// Construct character count array from the input</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// string.</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">int</code> <code class="plain">len = </code><code
            class="functions bold">strlen</code><code class="plain">(str);</code></div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">int</code> <code class="plain">max = 0;&nbsp; </code><code
            class="comment">// Initialize max count</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">char</code> <code class="plain">result;&nbsp;&nbsp; </code><code
            class="comment">// Initialize result</code></div>
    <div class="line number18 index17 alt1">&nbsp;</div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// Traversing through the string and maintaining</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// the count of each character</code></div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">for</code> <code class="plain">(</code><code class="keywords">int</code> <code
            class="plain">i = 0; i &lt; len; i++) &#123;</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">count[str[i]]++;</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">if</code> <code class="plain">(max &lt; count[str[i]]) &#123;</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max = count[str[i]];</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">result = str[i];</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number28 index27 alt1">&nbsp;</div>
    <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">return</code> <code class="plain">result;</code></div>
    <div class="line number30 index29 alt1"><code class="plain">&#125;</code></div>
    <div class="line number31 index30 alt2">&nbsp;</div>

    
    <div class="line number33 index32 alt2"><code class="keywords">int</code> <code class="plain">main()</code></div>
    <div class="line number34 index33 alt1"><code class="plain">&#123;</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">char</code> <code class="plain">str[] = </code><code
            class="string">"sample string"</code><code class="plain">;</code></div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Max occurring character is "</code></div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&lt;&lt; getMaxOccuringChar(str);</code></div>
    <div class="line number38 index37 alt1"><code class="plain">&#125;</code></div>
</div>
<div className='output'>
    <p><strong>Output:</strong></p>
    Max occurring character is s
</div>
        </div>
    )
}

export default Cp_mStr
